import AddressDisplay from 'common/components/address/AddressDisplay';

const CustomerDetails = (props) => {
  const { reservation } = props;
  const { billTo } = reservation;
  return (
    <div className="c7-order__customer-detail">
      <h4>Customer information</h4>
      <div>
        {billTo && (
          <span>
            <strong>Billing Address</strong>
            <br />
            <AddressDisplay address={billTo} />
          </span>
        )}
      </div>
    </div>
  );
};

export default CustomerDetails;
